import { defineAsyncComponent } from 'vue';
import { mountVueComponent } from '@/components/mountVueComponents';

// const dealerSearchEl = document.querySelector('.js-dealer-search');
// if (dealerSearchEl) {
//   const DealerSearch = defineAsyncComponent(() => import('./DealerSearch.vue'));
//   mountVueComponent(dealerSearchEl, DealerSearch, 'Dealer-Search');
// }

const dealerSearchContactsEl = document.querySelector('.js-dealer-search-contacts');
if (dealerSearchContactsEl) {
  const DealerSearchContacts = defineAsyncComponent(() => import('./DealerSearchContacts.vue'));
  mountVueComponent(dealerSearchContactsEl, DealerSearchContacts, 'Dealer-Search-Contacts');
}
